export default __webpack_public_path__ + "static/media/chain-14.c284faad.png";